import { Button, Col, Divider, Dropdown, Form, Input, Modal, Row, Select, Space, Table, Tag, Typography } from 'antd';
import React, { useEffect, useState } from 'react';
import { useComing } from './ComingStore';
import { useProducts } from '../Params/Products/ProductStore';
import {
    PlusOutlined,
    SearchOutlined,
    AppstoreOutlined,
    SaveOutlined,
    InboxOutlined,
    ShoppingCartOutlined,
} from '@ant-design/icons';
import { MAIN_URL } from '../../Constants';
import { useCustomers } from '../Customers/CustomersStore';
import AddCustomer from '../Customers/Add';
import { useVariations } from '../Params/Products/Variations/VarStore';
import emptyimg from './../../assets/images/emptyimage.jpg';
import css from './Income.module.css';

const sum = (v) => Number(v || 0).toLocaleString('ru-RU').replace(/,/g, ' ');

const qualityLabel = (q) =>
    q === '1' ? 'Original' : q === '2' ? 'Podoriginal' : 'Xitoy poddelka';

function Coming() {
    const { searchItem, sitems, scolumns, selected, setSelected, create, render } = useComing();
    const { fetchProducts, vrs } = useProducts();
    const { fetchCustomers, customers } = useCustomers();
    const [openCustomer, setOpenCustomer] = useState(false);
    const { getVariations, variations } = useVariations();
    const [vmodal, setVmodal] = useState(false);

    useEffect(() => {
        fetchProducts();
        fetchCustomers();
    }, [render]);

    const handleVariants = (prd) => {
        getVariations(prd.id);
        setVmodal(true);
    };

    const dropdownItems = sitems.map((item) => ({
        key: item.id,
        label: item.nameuz,
        onClick: () => setSelected(item),
    }));

    return (
        <>
            {/* ---- Variantlar modali ---- */}
            <Modal open={vmodal} footer={false} title="Variantni tanlang" width="80%" onCancel={() => setVmodal(false)}>
                <div className={css.variantGrid}>
                    {variations.map((item) => (
                        <div
                            key={item.id}
                            className={css.variantCard}
                            onClick={() => { setSelected(item); setVmodal(false); }}
                        >
                            <img
                                className={css.variantThumb}
                                alt={item.product}
                                src={item.img ? MAIN_URL + '/' + item.img : emptyimg}
                            />
                            <div className={css.variantBody}>
                                <div className={css.variantTop}>
                                    <div className={css.variantTitle}>
                                        <Typography.Text strong>{item.product} - {item.sku}</Typography.Text>
                                        <div className={css.variantMeta}>{item.country} | {item.manufacturer}</div>
                                    </div>
                                    <Tag style={{ marginInlineEnd: 0, backgroundColor: item.color_code, color: '#fff', border: 'none' }}>
                                        {item.color}
                                    </Tag>
                                </div>
                                <Space size={[4, 4]} wrap style={{ marginTop: 10 }}>
                                    <Tag color={item.count > 0 ? 'green' : 'red'} style={{ marginInlineEnd: 0 }}>Qoldiq: {item.count} ta</Tag>
                                    <Tag color="blue">{qualityLabel(item.quality)}</Tag>
                                    <Tag>{item.b_u === '1' ? 'Ishlatilgan' : 'Yangi'}</Tag>
                                </Space>
                                <div className={css.priceBox}>
                                    <span>{sum(item.price_uzs)} so'm</span>
                                    <span>{item.price_usd} $</span>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </Modal>

            <Modal open={openCustomer} footer={null} onCancel={() => setOpenCustomer(false)} title="Yangi yetkazib beruvchi">
                <AddCustomer />
            </Modal>

            <Row gutter={[16, 16]}>
                {/* ---- Chap: qidiruv + savat + kirim formasi ---- */}
                <Col xs={24} lg={17}>
                    <div className={css.stack}>
                        {/* Qidiruv + savat */}
                        <div className={`${css.panel} ${css.cartPanel}`}>
                            <div className={css.panelHeader}>
                                <Dropdown menu={{ items: dropdownItems }} open={dropdownItems.length ? undefined : false} trigger={['click']}>
                                    <Input
                                        size="large"
                                        allowClear
                                        prefix={<SearchOutlined style={{ color: 'var(--text-muted)' }} />}
                                        placeholder="Tovar nomi, SKU yoki kod bo'yicha qidiring..."
                                        onChange={(e) => searchItem(e.target.value)}
                                    />
                                </Dropdown>
                            </div>
                            <div className={css.cartWrap}>
                                {selected.length ? (
                                    <Table
                                        columns={scolumns}
                                        dataSource={selected}
                                        rowKey="id"
                                        size="small"
                                        pagination={false}
                                        scroll={{ x: 'max-content' }}
                                    />
                                ) : (
                                    <div className={css.cartEmpty}>
                                        <ShoppingCartOutlined />
                                        <div>Hali tovar qo'shilmagan — qidiring yoki o'ngdan tanlang</div>
                                    </div>
                                )}
                            </div>
                        </div>

                        {/* Kirim ma'lumotlari */}
                        <div className={css.panel}>
                            <div className={css.panelHeader}>
                                <h3 className={css.panelTitle}><InboxOutlined /> Kirim ma'lumotlari</h3>
                            </div>
                            <div className={css.panelBody}>
                                <Form layout="vertical" onFinish={(values) => {
                                    let summa = selected.reduce((s, item) => s + (item.price * item.count), 0);
                                    values.summa = summa;
                                    values.items = selected;
                                    create(values);
                                }}>
                                    <Row gutter={16}>
                                        <Col xs={24} sm={12} md={8}>
                                            <Form.Item name={'date'} label='Qabul qilingan sana'>
                                                <Input type='date' />
                                            </Form.Item>
                                        </Col>
                                        <Col xs={24} sm={12} md={8}>
                                            <Form.Item name={'deliver'} label='Olib keluvchi'>
                                                <Input placeholder="F.I.O" />
                                            </Form.Item>
                                        </Col>
                                        <Col xs={24} sm={12} md={8}>
                                            <Form.Item name={'suplier'} label='Kimdan xarid qilindi'>
                                                <Space.Compact style={{ width: '100%' }}>
                                                    <Select
                                                        style={{ width: '100%' }}
                                                        showSearch
                                                        optionFilterProp="label"
                                                        placeholder="Yetkazib beruvchi"
                                                        options={customers.map((item) => ({
                                                            value: item.id,
                                                            label: item.last_name + ' ' + item.first_name,
                                                        }))}
                                                    />
                                                    <Button type='primary' onClick={() => setOpenCustomer(true)} icon={<PlusOutlined />} />
                                                </Space.Compact>
                                            </Form.Item>
                                        </Col>
                                        <Col xs={24} sm={12} md={8}>
                                            <Form.Item name={'auto'} label='Mashina raqami'>
                                                <Input placeholder="01 A 123 BC" />
                                            </Form.Item>
                                        </Col>
                                        <Col xs={24} sm={12} md={8}>
                                            <Form.Item name={'document'} label='Hujjat raqami'>
                                                <Input placeholder="№" />
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                    <Divider style={{ margin: '4px 0 16px' }} />
                                    <Button type='primary' size="large" htmlType='submit' icon={<SaveOutlined />} disabled={!selected.length}>
                                        Kirimni saqlash
                                    </Button>
                                </Form>
                            </div>
                        </div>
                    </div>
                </Col>

                {/* ---- O'ng: mahsulotlar ---- */}
                <Col xs={24} lg={7}>
                    <div className={`${css.panel} ${css.sidePanel}`}>
                        <div className={css.panelHeader}>
                            <h3 className={css.panelTitle}><AppstoreOutlined /> Mahsulotlar</h3>
                            <Tag>{vrs.length}</Tag>
                        </div>
                        <div className={css.panelBody}>
                            <div className={css.productGrid}>
                                {vrs.map((item) => (
                                    <div key={item.id} className={css.productCard} onClick={() => handleVariants(item)}>
                                        <span className={`${css.stockBadge} ${item.count > 0 ? css.inStock : css.outStock}`}>
                                            {item.count}
                                        </span>
                                        <img
                                            className={css.productThumb}
                                            alt={item.nameuz}
                                            src={item.img ? MAIN_URL + '/' + item.img : emptyimg}
                                        />
                                        <div className={css.productInfo}>
                                            <div className={css.productTags}>
                                                {item.brands?.slice(0, 2).map((brand, index) => (
                                                    <Tag key={index} color="success" style={{ marginInlineEnd: 0 }}>{brand.nameuz}</Tag>
                                                ))}
                                                {item.models?.slice(0, 2).map((model, index) => (
                                                    <Tag key={index} color="blue" style={{ marginInlineEnd: 0 }}>{model.nameuz}</Tag>
                                                ))}
                                            </div>
                                            <div className={css.productName}>{item.nameuz}</div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </Col>
            </Row>
        </>
    );
}

export default Coming;
